var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.144,
    height: 16.164,
    viewBox: "0 0 14.144 16.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#343434;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M98.795.016,92.733,0a2.1,2.1,0,0,0-2.021,2.021l-.584.014a2.023,2.023,0,0,0-1.942,2.007v10.1a2.1,2.1,0,0,0,2.021,2.02h7.577a2.1,2.1,0,0,0,2.021-2.02h.505a2.1,2.1,0,0,0,2.021-2.02V4.053Zm-1.01,15.138H90.208a1.059,1.059,0,0,1-1.01-1.01V4.041c0-.752.618-1.01,1.515-1.01v9.092a2.1,2.1,0,0,0,2.021,2.02l6.066-.006A.955.955,0,0,1,97.784,15.154Zm1.01-4.541H94.249a.5.5,0,1,1,0-1.009h4.546a.5.5,0,1,1,0,1.009Zm0-2.523H94.249a.5.5,0,1,1,0-1.009h4.546a.5.5,0,1,1,0,1.009ZM99.8,4.041a1.046,1.046,0,0,1-1.01-1.01v-2h0l2.526,3.016Z",
    transform: "translate(-88.187)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.f293721030ec356f2c0c42d72efcb98f.svg";
export { ForwardRef as ReactComponent };